let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lHDFC")).then(() => parcelRequire('2Qcwu'));